import { render, staticRenderFns } from "./xinziHuiZong.vue?vue&type=template&id=67c27c20&scoped=true&"
import script from "./xinziHuiZong.vue?vue&type=script&lang=js&"
export * from "./xinziHuiZong.vue?vue&type=script&lang=js&"
import style0 from "./xinziHuiZong.vue?vue&type=style&index=0&id=67c27c20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c27c20",
  null
  
)

export default component.exports